export default {
  title: 'Descontos e formas de pagamento',
  headers: {
    type: 'Tipo',
    class: 'Classe de desconto/encargo',
    description: 'Descrição',
    base: 'Base',
    percent: '(%)',
    amount: 'Valor',
    document: 'NIF/CIF emissor',
    date: 'Data',
    serie: 'Série-Número'
  }
}